import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi', 'kn', 'ml', 'te', 'ta', 'gu', 'mr', 'bn', 'ur'],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    ns: [
      'common', 'landing', 'auth', 'profile', 'navigation', 'dashboard', 
      'subjects', 'test', 'loader', 'reports', 'about', 'contact', 
      'faq', 'help', 'privacy', 'terms', 'model_paper', 'exam_booster', 'subscriptions', 'pricing'
    ],
    defaultNS: 'common',
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

export default i18n;
